import React from 'react';
import { IconMap, IconType } from './icons';
import { IconContainer } from './styles';
import { themeColor} from '../../layout/global-style';

export * from './icons';

export const Icon = ({ type = IconType.arrowLeft, color = themeColor.black, className }) => {
  if (!type || type === IconType.none || IconMap[type] === undefined) return null;
  const IconImg = IconMap[type];
  return (<IconContainer className={className}><IconImg color={color} /></IconContainer>);
};
export default Icon;
